import React from 'react';
import styled from 'styled-components';
import constants from 'utils/constants';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import DotButton from 'components/presenters/button/DotButton';
import CommunityPostFooter from 'components/presenters/community/CommunityPostFooter';

export default function CommunityList({
    postList, 
    userInfo, 
    handleBottomModal, 
    handleAddLike,
    handleDeleteLike,
    currPostNo,
    isLikeAnimation,
    lottieOptions,
    type,
    isOwner,
    onCommentClick
}) {    
    const postType = {
        free_topic: '자유글',
        review: '후기',
        greeting: '가입인사',
        info: '정보'
    }

    let imageDomain = null;
    if(type === 'campaign')
    {
        imageDomain = 'campaign_post_img'
    }
    else if(type === 'group')
    {
        imageDomain = 'group_post_img'
    }
    
    return (
        <CommunityListSection>
            {postList.map((postItem) => {
                const postDetailLink = type === 'campaign' ? `/campaign/${postItem['campaign_no']}/post/${postItem['no']}` : `/group/${postItem['group_no']}/post/${postItem['no']}`
                const isPin = postItem['pin'] ? {background: '#ffefce'} : {background: '#fff'};
                return (        
                <CommunityItem key={`post_item_no_${postItem['no']}`} isPin={isPin}>
                    <CommunityTop>
                        <PostInfoBlock>
                            <Link to={`/task/friend/${postItem?.user_no}/list`}>
                                <UserImageBlock>
                                    <UserImage src={`${constants.imagePath}/user_profile_img/${postItem['profile_img']}`}/>
                                </UserImageBlock>
                            </Link>
                            <PostInfo>
                                <ComunnityUserInfoTop>
                                    <UserName>{postItem['nickname']}</UserName>
                                    <PostType>{postType[postItem['post_type']]}</PostType>
                                </ComunnityUserInfoTop>
                                <PostCreateDate>{format(new Date(postItem['create_date']), 'yyyy/MM/dd, HH:mm')}</PostCreateDate>
                            </PostInfo>
                        </PostInfoBlock>
                        <DotButtonBlock>
                            {postItem['user_no'] === userInfo['id'] || isOwner ? (
                                <DotButton onClick={() => handleBottomModal(postItem)} />
                            ) : null}
                        </DotButtonBlock>
                    </CommunityTop>
                    <ContentLink to={postDetailLink}>
                        <ContentBlock>
                                <Content>{postItem['content']}</Content>
                                {postItem['img_attachment'] && postItem['img_attachment'].length !== 0 ? (
                                    <PostImgAttachment src={`${constants.imagePath}/${imageDomain}/${postItem['img_attachment'][0]}`} />
                                ) : null}
                        </ContentBlock>
                    </ContentLink>
                    <CommunityPostFooter 
                        post={postItem}
                        onAddLikeClick={handleAddLike}
                        onDeleteLikeClick={handleDeleteLike}
                        currPostNo={currPostNo}
                        isLikeAnimation={isLikeAnimation}
                        lottieOptions={lottieOptions}
                        onCommentClick={onCommentClick}
                    />
                </CommunityItem>
                )
            })}
        </CommunityListSection>
    )
}

const CommunityListSection = styled.ul``;

const CommunityItem = styled.li`
    margin-top: calc(100vw * (14 / 375));
    width: 100%;
    border: solid calc(100vw*(1/375)) #eaeaea;
    border-radius: calc(100vw * (5 / 375));
    padding: calc(100vw * (8 / 375)) calc(100vw * (12 / 375))
      calc(100vw * (5 / 375)) calc(100vw * (12 / 375));
    background-color: ${({isPin}) => isPin['background']};
`;

const CommunityTop = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: calc(100vw * (10 / 375));
`;

const PostInfoBlock = styled.div`
    display: flex;
    align-items: center;
`;

const UserImageBlock = styled.div`
    display: block;
    width: calc(100vw * (42 / 375));
    height: calc(100vw * (42 / 375));
    border-radius: 50%;
    border: solid calc(100vw * (1 / 375)) #c6c6c6;
    overflow: hidden;
`;

const UserImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const PostInfo = styled.div`
    margin-left: calc(100vw * (10 / 375));
`;

const ComunnityUserInfoTop = styled.div`
    display: flex;
    align-items: center;
`;

const UserName = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 700;
`;

const PostCreateDate = styled.span`
    font-size: calc(100vw * (12 / 375));
    color: #989898;
    margin-top: calc(100vw * (1 / 375));
`;

const PostType = styled.span`
    width: calc(100vw * (74 / 375));
    height: calc(100vw * (26 / 375));
    border-radius: calc(100vw * (5 / 375));
    background-color: #F7F7F7;
    margin-left: calc(100vw * (7 / 375));
    font-size: calc(100vw * (11 / 375));
    font-weight: 500;
    line-height: calc(100vw * (26 / 375));
    text-align: center;
    color: #4E4E4E;
`;

const DotButtonBlock = styled.div`
    position: absolute;
    top: calc(100vw * (6 / 375));
    right: calc(100vw * (14 / 375));
`;

const ContentLink = styled(Link)`
    width: 100%;
`;

const ContentBlock = styled.div``;

const Content = styled.p`
    font-size: calc(100vw * (14 / 375));
    line-height: 1.5;
    color: #1d1d1d;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;
`;

const PostImgAttachment = styled.img`
    width: 100%;
  margin-top: calc(100vw * (8 / 375));
`;